import { render, staticRenderFns } from "./BasicContentConfigComponent.vue?vue&type=template&id=801b2574&"
import script from "./BasicContentConfigComponent.vue?vue&type=script&lang=js&"
export * from "./BasicContentConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports